import { css } from '@emotion/react'
import React from 'react'
import { colors, font } from 'plume-ui'
import { CheckIcon } from '../atoms/CheckIcon'
import { IcomoonIcon } from '../atoms/IcomoonIcon'
import { LoadableButton } from '../atoms/LoadableButton'

type Props = {
  isFollowed: boolean
  onFollow: () => void
  onUnfollow: () => void
  className?: string
  theme?: 'light-bg' | 'dark-bg'
  disabled?: boolean
  isLoading?: boolean
}

export const FollowButton: React.FC<Props> = ({
  theme = 'light-bg',
  ...props
}) => {
  return props.isFollowed ? (
    <FollowedButton theme={theme} {...props} className="follow-button" />
  ) : (
    <ToFollowButton theme={theme} {...props} className="follow-button" />
  )
}

const FollowedButton: React.FC<Props> = (props) => {
  const color = '#1b8298'
  const hoverBgColor = '#00596A'

  return (
    <LoadableButton
      size="small"
      css={css`
        flex-shrink: 0;
        color: ${colors.white00};
        border: 1px solid ${color};
        background-color: ${color};
        display: flex;
        column-gap: 2px;
        justify-content: center;
        align-items: center;
        padding-block: 6px !important;
        padding-inline: 13.5px !important;
        font-size: 12px;
        font-weight: ${font.weight.bold};
        line-height: 1;
        letter-spacing: 0.02em;
        white-space: nowrap;
        &:hover {
          color: ${colors.white00};
          background-color: ${hoverBgColor};
          border-color: ${hoverBgColor};
        }
        & > i {
          font-size: 14px;
        }
      `}
      className={props.className}
      onClick={props.onUnfollow}
      isLoading={props.isLoading}
      spinnerColor={colors.white00}
    >
      <CheckIcon />
      <span>フォロー中</span>
    </LoadableButton>
  )
}

const ToFollowButton: React.FC<Props> = (props) => {
  const color = props.theme === 'light-bg' ? '#1b8298' : colors.white00
  const bgColor = props.theme === 'light-bg' ? colors.white00 : 'transparent'

  return (
    <LoadableButton
      size="small"
      css={css`
        flex-shrink: 0;
        color: ${color};
        border: 1px solid ${color};
        background-color: ${bgColor};
        display: flex;
        column-gap: 2px;
        justify-content: center;
        align-items: center;
        padding-block: 6px !important;
        padding-inline: 13.5px !important;
        font-size: 12px !important;
        font-weight: ${font.weight.bold};
        line-height: 1;
        letter-spacing: 0.02em;
        white-space: nowrap;
        &:hover {
          color: ${props.disabled ? color : '#2da5be'};
          border-color: ${props.disabled ? color : '#2da5be'};
          background-color: ${bgColor};
          cursor: ${props.disabled ? 'default' : 'pointer'};
        }
        & > i {
          font-size: 14px;
        }
      `}
      className={props.className}
      onClick={props.onFollow}
      isLoading={props.isLoading}
      spinnerColor={color}
    >
      <PlusIcon />
      <span>フォロー</span>
    </LoadableButton>
  )
}

const PlusIcon = () => {
  return <IcomoonIcon name="plus"></IcomoonIcon>
}
